import {useEffect} from 'react';

import constantsFactory from '@/utils/constants';
import {on, off} from '@/utils/events';
import {STORAGE_KEY_ESTIMATES, STORAGE_KEY_SESSIONS} from './utils';

const {EVENTS} = constantsFactory();

/**
 * @description Custom hook to cleanup managed shipping related data on user logout.
 * It listens for the logout event and clears the relevant localStorage keys.
 */
const useCleanupManagedShipping = () => {
  /** Clear cache on user logout event */
  useEffect(() => {
    const handleClear = () => {
      window.localStorage.removeItem(STORAGE_KEY_SESSIONS);
      window.localStorage.removeItem(STORAGE_KEY_ESTIMATES);
    };
    on(EVENTS.LOGOUT_SUCCESS, handleClear);

    return () => {
      off(EVENTS.LOGOUT_SUCCESS, handleClear);
    };
  }, []);
};

export default useCleanupManagedShipping;
